export default __webpack_public_path__ + "static/media/landing2.93540418.jpg";